module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/kateryna-tkachenko-6f139490edce73f6e854999c11ae4db9.webp";